import { useEffect, useState } from 'react';
import { ProceedingItem } from '../components/proceedingItem';
import './proceedings.css';
import { Options, SelectButton } from '../components/selectButton';
import { ReactComponent as OptionsSVG } from '../images/options.svg';
import { ReactComponent as SearchSVG } from '../images/search.svg';
import { ReactComponent as DocumentsSVG } from '../images/documents.svg';
import { SquaredIcon } from '../components/squaredIcon';
import { useNavigate } from 'react-router-dom';
import { get, post } from './utils/utils';
import { useAuth } from '../context/context';

export interface Proceeding {
  id: string;
  internalNumber: string;
  courtNumber?: string;
  open?: string;
  close?: string;
  idStatus: string;
  idBranch: string;
  idType?: string;
  client?: string;
  idResolution?: string;
  starred?: string;
  phone?: string;
  mail?: string;
  implication?: string;
  description?: string;
  idCourt?: string;
  signature?: string;
  notes?: string;
  type?: string;
}

export function Proceedings() {
  const [loading, setLoading] = useState<boolean>(true);
  const [proceedings, setProceedings] = useState<Proceeding[]>([]);
  const [selectedOption, setSelectedOption] = useState<string>('');
  const [displayedProceedings, setDisplayedProceedings] = useState<
    Proceeding[]
  >([]);
  const [internalNumberFilter, setInternalNumberFilter] = useState<string>('');
  const [options, setOptions] = useState<Options[]>([]);
  let navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    get({
      url: 'status.php',
      token: user.token
    })
      .then((response) => response.data)
      .then((data) => {
        const opciones = data.map((option: any) => ({
          id: option.id,
          name: "Estatus: " + option.name
        }));
        opciones.push({
          id: '4',
          name: 'Destacado'
        })
        setOptions(opciones);
        setSelectedOption(data[0].id);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  useEffect(() => {
    get({
      url: 'proceedings.php',
      token: user.token,
    })
      .then((response) => response.data)
      .then((data) => {
        console.log('Proceedings: ', data);
        setProceedings(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching options:', error);
      });
  }, []);

  function onSelectChange(event: any) {
    setSelectedOption(event.target.value);
  }

  useEffect(() => {
    let filterProceedings;
    if(selectedOption === '4') {
      filterProceedings = proceedings.filter(
        (proceeding) => proceeding.starred === '1'
      );
    } else {
      filterProceedings = proceedings.filter(
        (proceeding) => proceeding.idStatus === selectedOption
      );
    }
    filterProceedings = filterProceedings.filter((proceeding) =>
      proceeding.internalNumber.includes(internalNumberFilter)
    );
    setDisplayedProceedings(filterProceedings);
  }, [selectedOption, internalNumberFilter, proceedings]);

  function postStarredProceeding(proceeding: Proceeding) {
    const formData = new FormData();
    let starred = '0';
    if(!proceeding.starred || proceeding.starred == '0') starred = '1';
    formData.append('id', proceeding.id);
    formData.append('starred', starred);
    post({
      url: 'postProceedingStar.php',
      data: formData,
      token: user.token,
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status === 'ok') {
          const copyProceedings = [...proceedings];
          const starredProceeding = copyProceedings.find((proc) => proc.id == proceeding.id);
          if(starredProceeding) starredProceeding.starred = starred;
          setProceedings(copyProceedings);
        }
      })
      .catch((error) => {
        alert(error.response.data.error);
      });
  }

  return (
    <div>
      <div className="proceedings-container">
        <div className="proceedings-list">
          <div className="proceedings-search">
            <input
              className="proceedings-search-input"
              type="text"
              onChange={(event) => setInternalNumberFilter(event?.target.value)}
            />
            <div className="proceedings-search-icon">
              <SearchSVG />
            </div>
          </div>
          <SelectButton
            icon={<OptionsSVG />}
            selectedOption={selectedOption}
            options={options}
            onChange={onSelectChange}
          />
          {loading ? (
            <p>Cargando expedientes...</p>
          ) : (
            <div className="proceedings-listing">
              {displayedProceedings.map((proceeding) => (
                <ProceedingItem proceeding={proceeding} handleStarred={postStarredProceeding}/>
              ))}
            </div>
          )}
        </div>
        <div className="proceedings-add">
          <p>Iniciar nuevo expediente</p>
          <SquaredIcon
            icon={<DocumentsSVG />}
            onClick={() => navigate('nuevo')}
          />
        </div>
      </div>
    </div>
  );
}
